/*
 * Nokian Tyres theme for Material UI.
 */

import { createTheme } from '@material-ui/core/styles';

import NokianTyresSansWOFF2 from './assets/fonts/NokianTyresSans-Regular.woff2';
import NokianTyresSansBoldWOFF2 from './assets/fonts/NokianTyresSans-Bold.woff2';

const NokianTyresSans = {
  fontFamily: 'Nokian Tyres Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: ` url(${NokianTyresSansWOFF2}) format('woff2') `
};

const NokianTyresSansBold = {
  fontFamily: 'Nokian Tyres Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: ` url(${NokianTyresSansBoldWOFF2}) format('woff2') `
};

const theme = createTheme({
  brandFont: 'Nokian Tyres Sans',
  palette: {
    primary: {
      main: '#4BA842',
      50: '#DAFFD7',
      500: '#4BA842',
      600: '#367C30',
      700: '#2C6628',
      900: '#1E461B'
    },
    background: {
      sidebar: '#F6F5F3'
    },
    error: {
      main: '#B00020'
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [NokianTyresSans, NokianTyresSansBold],
        html: {
          height: '100%'
        },
        body: {
          backgroundColor: '#ffffff',
          height: '100%'
        },
        '#root': {
          height: '100%'
        }
      },
    }
  },
});

export default theme;
